import { useState, useEffect } from "react";

interface CurveLineProps {
  isActive?: boolean;
  className?: string;
}

const LeftCurveLine = ({ isActive = false, className = "" }: CurveLineProps) => {
  const [pathLength, setPathLength] = useState(0);
  const activeColor = "#8FE45A";
  const inactiveColor = "rgb(var(--pd-rule))";

  useEffect(() => {
    if (isActive) {
      // Start animation with a small delay
      const timer = setTimeout(() => {
        setPathLength(1);
      }, 400);
      return () => clearTimeout(timer);
    } else {
      setPathLength(0);
    }
  }, [isActive]);

  return (
    <svg
      width={242}
      height={247}
      viewBox="0 0 242 247"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Background dashed path (always visible) */}
      <path
        d="M242 1H17.0667C8.18982 1 0.999987 8.16 0.999987 17V175L1.39163 230.11C1.45188 238.9 8.63167 246 17.4583 246H240.996"
        stroke={inactiveColor}
        strokeWidth={2}
        strokeDasharray="10 10"
      />
      
      {/* Animated solid path - Note the reversed path definition */}
      <path
        d="M242 1H17.0667C8.18982 1 0.999987 8.16 0.999987 17V175L1.39163 230.11C1.45188 238.9 8.63167 246 17.4583 246H240.996"
        stroke={activeColor}
        strokeWidth={3}
        strokeDasharray="1000"
        strokeDashoffset={1000 - (pathLength * 1000)}
        style={{ transition: "stroke-dashoffset 2s ease-in-out" }}
      />
    </svg>
  );
};

export default LeftCurveLine;
